module.exports = __webpack_public_path__ + "cancel.svg?85be6e67b4468f1fba203acbf4cdac80";